module.exports = assert

function assert(condition, message) {
    if (!condition) {
        throw message || "Assertion failed";
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/ganache-core/~/web3-provider-engine/util/assert.js
// module id = 1428
// module chunks = 0 1 2